import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import {
  FaWhatsapp,
  FaLinkedinIn,
  FaFacebookF,
} from "react-icons/fa"
import { BsTwitterX } from "react-icons/bs";
import BlogCommentForm from "../components/blog-comment-form"
import BlogCommentList from "../components/blog-comment-list"
import BlogSidebar from "../components/blog-sidebar"
import Newsletter from "../components/newsletter"
import { StaticImage } from "gatsby-plugin-image"

const BlogPost = ({ pageContext }) => {
  //   console.log(pageContext)

  //   console.log(pageContext.yoast_head)

  const getData = graphql`
    {
      allWpPost(sort: {date: DESC}) {
        edges {
          node {
            categories {
              nodes {
                databaseId
                id
                name
                slug
              }
            }
            id
            databaseId
            title
            slug
            date(formatString: "DD/MM/yyyy")
            excerpt
            featuredImage {
              node {
                sourceUrl
                srcSet
                altText
              }
            }
          }
        }
      }
    }
  `

  const data = useStaticQuery(getData)
  // console.log(data);

  const related_posts = []
  data.allWpPost.edges.map(post =>
    post.node.categories.nodes.map(cat => {
      if (cat.id === pageContext.categories.nodes[0].id) {
        related_posts.push(post)
      }
      return true
    })
  )

  const getRelatedPosts = () =>
    related_posts.slice(0, 3).map((obj, index) => {
      const post = obj.node
      return (
        <div key={index} className="col-md-4">
          <article className="related-post">
            <span className="related-date">{post.date}</span>
            <h3 className="related-title">
              <Link to={`/${post.slug}/`}>{post.title}</Link>
            </h3>
            <div
              className="related-description"
              dangerouslySetInnerHTML={{ __html: post.excerpt }}
            />
          </article>
        </div>
      )
    })


  const BASE_URL = "https://www.brokalia.com/"
  const tw_link =
    "https://twitter.com/share?url=" + BASE_URL + pageContext.slug + "/"
  const fb_link =
    "https://www.facebook.com/sharer/sharer.php?u=" +
    BASE_URL +
    pageContext.slug +
    "/"
  const ln_link =
    "https://www.linkedin.com/shareArticle?mini=true&url=" +
    BASE_URL +
    pageContext.slug +
    "/"
  const wa_link = "https://wa.me/?text=" + BASE_URL + pageContext.slug + "/"

  return (
    <Layout className="page-blog page-blog-post">
      {/* <Seo title={pageContext.title} yoastHead={pageContext.yoast_head} /> */}
      <Seo title={pageContext.title} image={pageContext.featuredImage && pageContext.featuredImage.node.sourceUrl} />
      <section className="blog-header">
        <h2 className="title title-centered">El blog de Brokalia</h2>
      </section>
      <section className="blog-content container">
        <div className="blog-content-main">
          <div className="post">
            <div className="post-info-container">
              <aside className="post-info">
                {pageContext.tags && (
                  <span className="post-category">
                    <Link to={`/${pageContext.categories.nodes[0].slug}/`}>
                      {pageContext.categories.nodes[0].name}
                    </Link>
                  </span>
                )}
                <span className="post-date">{pageContext.date}</span>
              </aside>

              <ul className="social-share">
                <li>
                  <a href={tw_link} target="_blank" rel="nofollow noreferrer">
                    <BsTwitterX aria-label="Compartir en Twitter" />
                  </a>
                </li>
                <li>
                  <a href={fb_link} target="_blank" rel="nofollow noreferrer">
                    <FaFacebookF aria-label="Compartir en Facebook" />
                  </a>
                </li>
                <li>
                  <a href={ln_link} target="_blank" rel="nofollow noreferrer">
                    <FaLinkedinIn aria-label="Compartir en LinkedIn" />
                  </a>
                </li>
                <li>
                  <a href={wa_link} target="_blank" rel="nofollow noreferrer">
                    <FaWhatsapp aria-label="Compartir en Whatsapp" />
                  </a>
                </li>
              </ul>
            </div>

            <h1
              className="title post-title"
              dangerouslySetInnerHTML={{ __html: pageContext.title }}
            />

            <div
              className="post-content"
              dangerouslySetInnerHTML={{ __html: pageContext.content }}
            />

            {pageContext.tags && pageContext.tags.nodes.length > 0 && (
              <div className="post-tags">
                <span className="post-tags-label">Etiquetas:</span>

                {pageContext.tags.nodes.map((tag, index) => (
                  <Link
                    key={index}
                    className="btn-tag"
                    to={`/etiqueta/${tag.path ? "/" : tag.slug}/`}
                  >
                    {tag.name.split(" ")[0]}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <div className="banner-post">
            <div className="banner-content">
              <h4>¿Eres administrador de fincas? </h4>
              <p>¿Te gustaría saber cómo va la reparación de un siniestro de cualquier compañía en tiempo real? Sin eternas llamadas a la asistencia. Brokalia es tu solución. Pide una demo sin compromiso.</p>
            </div>
            <Link
              className="btn btn-accent"
              title="Planifica una demo"
              to="/solicitar-demo/"
            >
              Planificar una demo
            </Link>
          </div>

          <div className="author-container">
            <h3 className="title">Acerca del autor</h3>

            <div className="author">
              <img
                className="avatar"
                src={pageContext.author.node.avatar.url}
                alt={pageContext.author.node.name}
                loading="lazy"
                decoding="async"
                width="80"
                height="80"
              />
              <h5 className="author-name">{pageContext.author.node.name}</h5>
              <p
                className="author-description"
                dangerouslySetInnerHTML={{
                  __html: pageContext.author.node.description,
                }}
              />
            </div>
          </div>

          <BlogCommentList postId={pageContext.id} databaseId={pageContext.databaseId} />
          <BlogCommentForm postId={pageContext.databaseId} />
        </div>
        <BlogSidebar />
      </section>

      <section className="bloque bloque-newsletter">
        <div className="container">
          <h2 className="title">Suscríbete a nuestra Newsletter</h2>
          <div className="flex-between">
            <div className="newsletter-content">
              <p>
                No te pierdas <strong>las últimas novedades del sector de la administración de fincas</strong>.
                ¡Apuntate a nuestra newsletter! :)
              </p>
              <Newsletter />
            </div>
            <StaticImage
              src="../images/dibus/sidebar-newsletter.svg"
              alt="Suscríbete"
              className="img-newsletter"
              placeholder="none" // para SVG
              layout="constrained"
            />
          </div>
        </div>
      </section>

      {related_posts.length > 0 && (
        <section className="bloque bloque-related-posts">
          <div className="container">
            <h2 className="title">Artículos que te podrían interesar</h2>

            <div className="row">{getRelatedPosts()}</div>
          </div>
        </section>
      )}
    </Layout>
  )
}

export default BlogPost;